import { computed } from 'vue';

/**
 * Resolves the tenant timezone from the auth store. Backend tenant rows
 * carry a `timezone` field; if missing or unrecognised by Intl, fall back
 * to UTC (matches Story 1.11's default-with-warn behaviour on the server).
 */
export function useTenantTimezone(tenantRef) {
  const timezone = computed(() => {
    const tz = tenantRef?.value?.timezone;
    if (!tz || typeof tz !== 'string') return 'UTC';
    try {
      // Throws on unknown identifier; we use this side effect to validate.
      new Intl.DateTimeFormat('en-US', { timeZone: tz });
      return tz;
    } catch {
      return 'UTC';
    }
  });

  /** Format a Date or ISO string in the resolved timezone. */
  function format(value, options = { dateStyle: 'medium', timeStyle: 'short' }) {
    const d = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return new Intl.DateTimeFormat('en-US', { timeZone: timezone.value, ...options }).format(d);
  }

  return { timezone, format };
}
